import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { ModalController } from '@ionic/angular';
import { EChartsOption } from 'echarts';

type RatingKey = 'rating1' | 'rating2' | 'rating3' | 'rating4' | 'rating5';
@Component({
  selector: 'stats-popover',
  templateUrl: './stats-popover.component.html',
})
export class StatsPopoverComponent implements OnInit {
  @Input() ratingAverage!: number;
  @Input() ratingCount!: number;
  @Input() membersFollowing!: string;
  // @Input() averageCommitmentLevel!: string | number | null;
  @Input() commentCount!: string;
  @Input() backedCount!: number | null;
  @Input() uniqueViews!: string;
  @Input() userIndex!: number;
  @Input() userIndexDiff!: number;
  @Input() userIndexAmbassador!: number;
  @Input() userIndexCreator!: number;
  @Input() userIndexHelper!: number;
  @Input() totalRatings: number = 0;
  @Input() shareCount!: number;
  // @Input() commitmentLevelPercentages!: {
  //   percentageTo25: number;
  //   percentage25To50: number;
  //   percentage50To75: number;
  //   percentage75To100: number;
  // };
  @Input() userCommitmentLevel!: any;
  @Input() displayCharts: boolean = false;

  @Input() followerStats: { dateTime: string; value: number }[] = [];
  @Input() commentStats: { dateTime: string; value: number }[] = [];
  @Input() backingStats: { dateTime: string; value: number }[] = [];
  @Input() uniqueViewStats: { dateTime: string; value: number }[] = [];
  @Input() shareStats: { dateTime: string; value: number }[] = [];
  @Input() ratingStats!: Record<RatingKey, number>;

  stars: Array<1 | 2 | 3 | 4 | 5> = [5, 4, 3, 2, 1];
    

  @Output() closeEvent = new EventEmitter<void>();

  commitmentChartOptions!: EChartsOption;
  followerChartOptions!: EChartsOption;
  commentChartOptions!: EChartsOption;
  backingChartOptions!: EChartsOption;
  uniqueViewsChartOptions!: EChartsOption;
  shareChartOptions!: EChartsOption;

  activeCommentRange: '1D' | '1W' | '1M' | 'MAX' = 'MAX';
  activeFollowerRange: '1D' | '1W' | '1M' | 'MAX' = 'MAX';
  activeBackingRange: '1D' | '1W' | '1M' | 'MAX' = 'MAX';
  activeUniqueViewsRange: '1D' | '1W' | '1M' | 'MAX' = 'MAX';
  activeShareRange: '1D' | '1W' | '1M' | 'MAX' = 'MAX';

  filteredFollowerTotal!: number;
  filteredCommentTotal!: number;
  filteredBackingTotal!: number;
  filteredUniqueViewsTotal!: number;
  filteredShareTotal!: number;

  stats!: { icon: string; value: string | number; label: string }[];

  getStarIcon(star: number): string {
    const rating = this.ratingAverage
    if (rating >= star) return 'star-outline';
    if (rating >= star - 0.5) return 'half-star';

    return 'star';
  }

  getRatingCount(star: 1 | 2 | 3 | 4 | 5): number {
    const key = `rating${star}` as RatingKey;
    return this.ratingStats?.[key] ?? 0;
  }

  getRatingPercent(star: 1 | 2 | 3 | 4 | 5): number {
    const total = this.ratingCount;
    if (!total) return 0;

    return (this.getRatingCount(star) / total) * 100;
  }

  constructor(private modalCtrl: ModalController) {}

  ngOnInit() {
    this.stats = [
      { icon: 'heart', value: this.membersFollowing, label: 'Followers' },
      ...(this.backedCount != null
        ? [{ icon: 'backing', value: this.backedCount, label: 'Backers' }]
        : []),
      { icon: 'stats-star', value: this.ratingAverage, label: 'Average Rating' },
      { icon: 'chat', value: this.commentCount, label: 'Comments' },
      // ...(this.averageCommitmentLevel != null
      //   ? [
      //       {
      //         icon: 'check-circle',
      //         value: `${this.averageCommitmentLevel}%`,
      //         label: 'Average Commitment Level',
      //       },
      //     ]
        // : []),
      // { icon: 'stats', value: this.uniqueViews, label: 'Unique Views' },
      ...(this.shareCount != null
        ? [{ icon: 'share', value: this.shareCount, label: 'Shares' }]
        : []),
    ];

    // if (!this.commitmentLevelPercentages && this.displayCharts) {
    //   console.warn('No commitment data found, skipping chart init');
    //   return;
    // }

    if (this.displayCharts) {
      // this.initCommitmentChart();
      this.initFollowerChart();
      this.initBackingChart();
      this.initCommentChart();
      // this.initUniqueViewsChart();
      this.initShareChart();
    }
  }

  // Commitment Chart
  // private initCommitmentChart() {
  //   const values = {
  //     upto25: this.commitmentLevelPercentages?.percentageTo25,
  //     upto50: this.commitmentLevelPercentages?.percentage25To50,
  //     upto75: this.commitmentLevelPercentages?.percentage50To75,
  //     upto100: this.commitmentLevelPercentages?.percentage75To100,
  //   };

    // environment.log('Commitment chart values:', values);

    // const yMax = getAdaptiveYMax(Object.values(values));
    // environment.log('Commitment chart yMax:', yMax);

  //   this.commitmentChartOptions = {
  //     grid: { top: 20, left: 0, right: 10 },
  //     tooltip: { trigger: 'axis', confine: true },
  //     legend: { data: ['0–25%', '26–50%', '51–75%', '76–100%'] },
  //     xAxis: { type: 'category', data: ['Average Commitment level'] },
  //     yAxis: {
  //       type: 'value',
  //       max: yMax,
  //       interval: yMax / 2,
  //       axisLabel: { formatter: (value: number) => value.toLocaleString() },
  //     },
  //     series: [
  //       {
  //         name: '0–25%',
  //         type: 'bar',
  //         data: [values.upto25],
  //         itemStyle: { color: '#F0B94B' },
  //       },
  //       {
  //         name: '26–50%',
  //         type: 'bar',
  //         data: [values.upto50],
  //         itemStyle: { color: '#FA7882' },
  //       },
  //       {
  //         name: '51–75%',
  //         type: 'bar',
  //         data: [values.upto75],
  //         itemStyle: { color: '#A54B91' },
  //       },
  //       {
  //         name: '76–100%',
  //         type: 'bar',
  //         data: [values.upto100],
  //         itemStyle: { color: '#37A5D2' },
  //       },
  //     ],
  //   };
  // }

  // ---------------------------
  // Filter helper
  // ---------------------------
  private filterStatsByRange(
    stats: { dateTime: string; value: number }[],
    range: '1D' | '1W' | '1M' | 'MAX',
  ): { filtered: { dateTime: string; value: number }[]; total: number } {
    // environment.log(`Filtering stats for range: ${range}`, stats);

    if (range === 'MAX') {
      const total = stats.length ? stats[stats.length - 1].value : 0;
      return { filtered: stats, total };
    }

    const now = new Date();
    let cutoff: Date;

    switch (range) {
      case '1D':
        cutoff = new Date(now.getTime() - 24 * 60 * 60 * 1000);
        break;
      case '1W':
        cutoff = new Date(now.getTime() - 7 * 24 * 60 * 60 * 1000);
        break;
      case '1M':
        cutoff = new Date(now.getTime() - 30 * 24 * 60 * 60 * 1000);
        break;
    }

    const filtered = stats.filter((s) => new Date(s.dateTime) >= cutoff);
    const total = filtered.length ? filtered[filtered.length - 1].value : 0;

    return { filtered, total };
  }

  setFollowerRange(range: '1D' | '1W' | '1M' | 'MAX') {
    if (this.activeFollowerRange === range) return;

    this.activeFollowerRange = range;
    this.initFollowerChart();
  }

  setCommentRange(range: '1D' | '1W' | '1M' | 'MAX') {
    if (this.activeCommentRange === range) return;

    this.activeCommentRange = range;
    this.initCommentChart();
  }

  setBackingRange(range: '1D' | '1W' | '1M' | 'MAX') {
    if (this.activeBackingRange === range) return;

    this.activeBackingRange = range;
    this.initBackingChart();
  }

  setUniqueViewsRange(range: '1D' | '1W' | '1M' | 'MAX') {
    if (this.activeUniqueViewsRange === range) return;

    this.activeUniqueViewsRange = range;
    this.initUniqueViewsChart();
  }
  
  setShareRange(range: '1D' | '1W' | '1M' | 'MAX') {
    if (this.activeShareRange === range) return;

    this.activeShareRange = range;
    this.initShareChart();
  }

  // Charts
  // Comment Chart
  private initCommentChart() {
    const { filtered, total } = this.filterStatsByRange(
      this.commentStats,
      this.activeCommentRange,
    );
    this.filteredCommentTotal = total;
    this.commentChartOptions = this.initLineChart(
      filtered,
      this.activeCommentRange,
      '#4F46E5',
      'Comments',
    );
  }
  // Follower Chart
  private initFollowerChart() {
    const { filtered, total } = this.filterStatsByRange(
      this.followerStats,
      this.activeFollowerRange,
    );
    this.filteredFollowerTotal = total;
    this.followerChartOptions = this.initLineChart(
      filtered,
      this.activeFollowerRange,
      '#FA7882',
      'Followers',
    );
  }

  // Backing chart
  private initBackingChart() {
    const { filtered, total } = this.filterStatsByRange(
      this.backingStats,
      this.activeBackingRange,
    );
    this.filteredBackingTotal = total;
    this.backingChartOptions = this.initLineChart(
      filtered,
      this.activeBackingRange,
      '#37A5D2',
      'Backers',
    );
  }

  // Unique Views Chart
  private initUniqueViewsChart() {
    const { filtered, total } = this.filterStatsByRange(
      this.uniqueViewStats,
      this.activeUniqueViewsRange,
    );
    this.filteredUniqueViewsTotal = total;
    this.uniqueViewsChartOptions = this.initLineChart(
      filtered,
      this.activeUniqueViewsRange,
      '#55B96E',
      'Views',
    );
  }

  // Share Chart
  private initShareChart() {
    const { filtered, total } = this.filterStatsByRange(
      this.shareStats,
      this.activeShareRange,
    );
    this.filteredShareTotal = total;
    this.shareChartOptions = this.initLineChart(
      filtered,
      this.activeShareRange,
      '#A54B91',
      'Shares',
    );
  }

  // init reusable line chart
  private initLineChart(
    data: { dateTime: string; value: number }[],
    range: '1D' | '1W' | '1M' | 'MAX',
    color: string,
    label: string,
  ): EChartsOption {
    // No data case
    if (!data.length) {
      return {
        title: {
          text: 'No data available for this range',
          left: 'center',
          top: 'center',
          textStyle: { color: '#9ca3af', fontSize: 11, fontWeight: 500 },
        },
        xAxis: {
          type: 'category',
          data: [],
          axisLabel: { show: false },
          axisLine: { show: false },
          splitLine: { show: false },
        },
        yAxis: {
          type: 'value',
          axisLabel: { show: false },
          axisLine: { show: false },
          splitLine: { show: false },
        },
        series: [],
      };
    }

    const yMax = getAdaptiveYMax(data.map((s) => s.value));

    return {
      tooltip: {
        trigger: 'axis',
        formatter: (params: any) => {
          if (!params?.length) return '';
          const [time, value] = params[0].data;
          return `${getFormattedChartDate(time, range, true)}<br/>${label}: ${value}`;
        },
      },
      grid: { top: 20, left: 0, right: 10, bottom: 0 },
      xAxis: {
        type: 'category',
        data: data.map((s) => s.dateTime),
        axisLabel: {
          formatter: (v: string) =>
            getFormattedChartDate(new Date(v).getTime(), range),
          fontSize: 10,
        },
        axisLine: { show: true },
        splitLine: { show: false },
      },
      yAxis: {
        type: 'value',
        min: 0,
        max: yMax,
        interval: yMax / 2,
        axisLabel: { fontSize: 10 },
      },
      series: [
        {
          name: label,
          type: 'line',
          data: data.map((s) => [s.dateTime, s.value]),
          smooth: false,
          lineStyle: { width: 3 },
          symbol: 'circle',
          symbolSize: 5,
          showSymbol: true,
          itemStyle: { color },
        },
      ],
    };
  }

  async close() {
    const top = await this.modalCtrl.getTop();

    if (top) {
      await this.modalCtrl.dismiss();
    } else {
      this.closeEvent.emit();
    }
  }
}

// Adaptive Y Max helper
function getAdaptiveYMax(values: number[]): number {
  const maxValue = Math.max(...values);

  if (maxValue <= 100) return Math.ceil(maxValue / 10) * 10;
  if (maxValue <= 1000) return Math.ceil(maxValue / 100) * 100;
  if (maxValue <= 10000) return Math.ceil(maxValue / 1000) * 1000;
  if (maxValue <= 100000) return Math.ceil(maxValue / 5000) * 5000;
  if (maxValue <= 1000000) return Math.ceil(maxValue / 100000) * 100000;
  return Math.ceil(maxValue / 1000000) * 1000000;
}

// adaptive date formatter
export function getFormattedChartDate(
  dateInput: string | number | Date,
  range: '1D' | '1W' | '1M' | 'MAX',
  detailed = false,
): string {
  const date = new Date(dateInput);

  if (detailed) {
    // show a more detailed rate (used for tooltip currently)
    switch (range) {
      case '1D':
        return date.toLocaleString('en-US', {
          weekday: 'short',
          month: 'short',
          day: 'numeric',
          year: 'numeric',
          // hour: '2-digit',
          // minute: '2-digit',
          // hour12: false,
          // timeZone: 'UTC'
        });
      default:
        return date.toLocaleString('en-US', {
          weekday: 'short',
          month: 'short',
          day: 'numeric',
          year: 'numeric',
          // hour: '2-digit',
          // minute: '2-digit',
          // hour12: false,
          // timeZone: 'UTC'
        });
    }
  }

  const formatOptions: Record<string, Intl.DateTimeFormatOptions> = {
    '1D': {
      hour: '2-digit',
      minute: '2-digit',
      hour12: false,
      timeZone: 'UTC',
    },
    '1W': { weekday: 'short', timeZone: 'UTC' },
    '1M': { month: 'short', day: 'numeric', timeZone: 'UTC' },
    MAX: { month: '2-digit', year: '2-digit', timeZone: 'UTC' },
  };

  const options = formatOptions[range] || formatOptions['MAX'];
  return date.toLocaleString('en-US', options);
}
